// Libs
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { ReactElement } from 'react';
// Components, Layouts, Pages
// Others
// Styles, images, icons

export interface IColTablePdf<T> {
  key: string;
  title: string;
  width?: string | number;
  render?: (record: T, index: number) => ReactElement;
}

type Props<T> = {
  columns: IColTablePdf<T>[];
  data: T[];
};

const ProductTable = <T,>(props: Props<T>) => {
  //#region Destructuring Props
  const { columns, data } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.tableContainer}>
      <View style={styles.containerHeader}>
        {columns.map((col, index) => {
          return (
            <View key={index} style={[styles.col, { width: col.width }]}>
              <Text>{col.title}</Text>
            </View>
          );
        })}
      </View>

      <View style={styles.containerBody}>
        {data.map((item, index) => (
          <View style={styles.body} key={index}>
            {columns.map((column, rowIndex) => (
              <View key={rowIndex} style={[styles.row, { width: column.width }]}>
                {column.render && column.render(item, index)}
              </View>
            ))}
          </View>
        ))}
      </View>
    </View>
  );
};

export default ProductTable;

export const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: 1,
    borderColor: '#333333',
  },

  containerHeader: {
    width: '100%',
    flexDirection: 'row',
    borderBottomColor: '#333333',
    backgroundColor: '#333333',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
    flexGrow: 1,
    color: 'white',
  },

  containerBody: {
    flexDirection: 'column',
    borderBottomColor: '#333333',
    borderBottomWidth: 1,
    height: 'auto',
    flexGrow: 1,
    width: '100%',
    color: '#333333',
  },

  body: {
    flexDirection: 'row',
    borderBottomColor: '#333333',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 'auto',
    flexGrow: 1,
    width: '100%',
    color: '#333333',
  },

  col: {
    width: '100%',
    paddingRight: 8,
    paddingLeft: 8,
    height: 24,
    justifyContent: 'center',
  },

  row: {
    width: '100%',
    paddingRight: 8,
    paddingLeft: 8,
    minHeight: 24,
    height: '100%',
    borderRightWidth: 1,
    borderRightColor: '#333333',
    justifyContent: 'center',
  },
});
